/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
// import HorizontalTeamCard from "examples/Cards/TeamCards/HorizontalTeamCard";
import HorizontalBlogCard from "examples/Cards/BlogCards/HorizontalBlogCard";
import newsArray from "assets/texts/news.json";

// import img1 from "assets/images/home1.jpg";
// import img1 from "assets/images/narrentreffen4.jpg";

function importAll(r) {
  const images = {};
  r.keys().map((item) => {
    images[item.replace("./", "")] = r(item);
    return images;
  });
  return images;
}
const images = importAll(require.context("../../../assets/images/", false, /\.(png|jpe?g|svg)$/));

function News() {
  return (
    <MKBox
      component="section"
      variant="gradient"
      bgColor="dark"
      position="relative"
      py={6}
      px={{ xs: 2, lg: 0 }}
      mx={-2}
    >
      <Container>
        <Grid container>
          <Grid item xs={12} md={8} sx={{ mb: 6 }}>
            <MKTypography variant="h3" color="white">
              Aktuelles
            </MKTypography>
            <MKTypography variant="body2" color="white" opacity={0.8}>
              Klatsch und Tratsch aus dem Bietinger Narrendorf. Mehr findest du auf Instagram und
              Facebook...
            </MKTypography>
          </Grid>
        </Grid>
        <Grid container spacing={3} mb={4}>
          {newsArray.map((row) => (
            <Grid key={row.title} item xs={12} lg={6}>
              <MKBox mb={1}>
                <HorizontalBlogCard
                  image={images[`${row.img}`]}
                  // image={img1}
                  name={row.title}
                  description={row.text}
                />
              </MKBox>
            </Grid>
          ))}
        </Grid>
      </Container>
    </MKBox>
  );
}
export default News;
